module.exports = __webpack_public_path__ + "view/2019/img/5031-statuario-maxima-cu-landscape-horizontal-book-mockup-3-mask.png";